module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori@2x-8452b25899270511d7fe45c04d25975f.webp";